import gql from 'graphql-tag';

export default gql`
  fragment unsubscribeMailCampaignProspectActivityFragment on UnsubscribeMailCampaignProspectActivity {
    id
    mailCampaignSend {
      id
      createdAt
      mailCampaign {
        id
        uuid
        title
        subject
        fromAddress
        fromName
        cc
        bcc
        sendAt
        isImmediately
        pool {
          uuid
        }
      }
    }
  }
`;
